module.exports = __webpack_public_path__ + "b967b04d744982f336e5010d6d9ad10c.png";